// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// CreateAPITokenUserHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import APITokenUser from './APITokenUser';
import ResultDTO from '../models/ResultDTO';

interface Request {
    userName: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            userName: "",
        },
        initValues);
    },
    userName: 'userName',
}

interface Result extends ResultDTO {
    user: APITokenUser | null;
    secret: string | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            user: null,
            secret: "",
        },
        initValues);
    },
    user: 'user',
    secret: 'secret',
}

export { Request, Result };